import * as React from "react";
import {Helmet} from "react-helmet";
import BreadcrumbsBlock from "../layouts/breadcrumbs-block/breadcrumbs-block";
import TitleBlock from "../layouts/title-block/title-block";
import FaqBlock from "../layouts/faq-block/faq-block";
import ActionButtonBlock from "../layouts/action-button-block/action-button-block";
import {GoogleAnalyticsEventType} from "../models/google-analytics";
import {PageType} from "../models/types";
import * as faqQuestionsData from "../constants/faq-questions-data";
import * as staticUrls from "../constants/static-urls";
import * as helmetData from "../constants/helmet-data";
import * as cacheBustingService from "../services/cache-busting-service";

interface FaqPageProps {}

interface FaqPageState {}

class FaqPage extends React.Component<FaqPageProps,FaqPageState> {

  componentDidMount() {
    cacheBustingService.handleCacheBusting(caches);
  }

  render() {
    return (
      <div>
        <Helmet {...helmetData.prepareHelmetData(PageType.FaqPage)}/>

        <BreadcrumbsBlock
          breadcrumbsElement={
            {
              elementName: "FAQ",
              elementDescription: ""
            }
          }
        />

        <TitleBlock
          firstLineBlackStart={"Najczęściej zadawane"}
          firstLineBlue={"pytania"}
          firstLineBlackEnd={""}
          secondLineText={"Zapoznaj się z odpowiedziami na najczęściej zadawane pytania."}
        />
        <FaqBlock
          faqQuestions={faqQuestionsData.FAQ_PAGE_FAQ_QUESTIONS}
          componentViewEventType={GoogleAnalyticsEventType.FaqPageViewedFaqBlock}
          faqQuestionReadEventType={GoogleAnalyticsEventType.FaqPageViewedFaqBlockQuestion}
        />
        <ActionButtonBlock
          actionButtonIntro={"Masz więcej pytań? Skontaktuj się z nami!"}
          actionButtonText={"KONTAKT"}
          actionButtonLinkTo={staticUrls.FAKTUROMANIA_KONTAKT_PAGE_URL}
          componentViewEventType={GoogleAnalyticsEventType.FaqPageViewedDetailsBlock}
          buttonClickEventType={GoogleAnalyticsEventType.FaqPageClickedCTAAtDetailsBlock}
        />

      </div>
    )
  }

}

export default FaqPage


// WEBPACK FOOTER //
// ./src/pages/faq.tsx